import { SafeArea } from 'capacitor-plugin-safe-area';

interface SafeAreaInsets {
  top: string;
  bottom: string;
  left: string;
  right: string;
}

const defaultInsets: SafeAreaInsets = {
  bottom: 'env(safe-area-inset-bottom)',
  left: 'env(safe-area-inset-left)',
  right: 'env(safe-area-inset-right)',
  top: 'env(safe-area-inset-top)'
};

export const initializeSafeArea = async (): Promise<SafeAreaInsets> => {
  try {
    const { insets } = await SafeArea.getSafeAreaInsets();

    console.debug('Received safe area insets:', insets);

    Object.entries(insets).forEach(([key, value]) => {
      document.documentElement.style.setProperty(
        `--safe-area-inset-${key}`,
        `${value}px`
      );
    });

    const safeAreaInsets: SafeAreaInsets = {
      bottom: 'var(--safe-area-inset-bottom)',
      left: 'var(--safe-area-inset-left)',
      right: 'var(--safe-area-inset-right)',
      top: 'var(--safe-area-inset-top)'
    };
    return safeAreaInsets;
  } catch (e) {
    console.debug('Could not get safe area insets, using env() values', e);
    return defaultInsets;
  }
};
